var EHttpStatusCodeSuccess = /*#__PURE__*/ function(EHttpStatusCodeSuccess) {
    EHttpStatusCodeSuccess[EHttpStatusCodeSuccess["OK"] = 200] = "OK";
    EHttpStatusCodeSuccess[EHttpStatusCodeSuccess["Created"] = 201] = "Created";
    EHttpStatusCodeSuccess[EHttpStatusCodeSuccess["Accepted"] = 202] = "Accepted";
    EHttpStatusCodeSuccess[EHttpStatusCodeSuccess["NoContent"] = 204] = "NoContent";
    return EHttpStatusCodeSuccess;
}(EHttpStatusCodeSuccess || {});
var EHttpStatusCodeRedirection = /*#__PURE__*/ function(EHttpStatusCodeRedirection) {
    EHttpStatusCodeRedirection[EHttpStatusCodeRedirection["Found"] = 302] = "Found";
    return EHttpStatusCodeRedirection;
}(EHttpStatusCodeRedirection || {});
var EHttpStatusCodeClientError = /*#__PURE__*/ function(EHttpStatusCodeClientError) {
    EHttpStatusCodeClientError[EHttpStatusCodeClientError["BadRequest"] = 400] = "BadRequest";
    EHttpStatusCodeClientError[EHttpStatusCodeClientError["Unauthorized"] = 401] = "Unauthorized";
    EHttpStatusCodeClientError[EHttpStatusCodeClientError["Forbidden"] = 403] = "Forbidden";
    EHttpStatusCodeClientError[EHttpStatusCodeClientError["NotFound"] = 404] = "NotFound";
    EHttpStatusCodeClientError[EHttpStatusCodeClientError["Conflict"] = 409] = "Conflict";
    EHttpStatusCodeClientError[EHttpStatusCodeClientError["Gone"] = 410] = "Gone";
    EHttpStatusCodeClientError[EHttpStatusCodeClientError["ImATeapotTrolling"] = 418] = "ImATeapotTrolling";
    EHttpStatusCodeClientError[EHttpStatusCodeClientError["UnprocessableEntity"] = 422] = "UnprocessableEntity";
    EHttpStatusCodeClientError[EHttpStatusCodeClientError["TooManyRequests"] = 429] = "TooManyRequests";
    return EHttpStatusCodeClientError;
}(EHttpStatusCodeClientError || {});
var EHttpStatusCodeServerError = /*#__PURE__*/ function(EHttpStatusCodeServerError) {
    EHttpStatusCodeServerError[EHttpStatusCodeServerError["InternalServerError"] = 500] = "InternalServerError";
    EHttpStatusCodeServerError[EHttpStatusCodeServerError["ServiceUnavailable"] = 503] = "ServiceUnavailable";
    EHttpStatusCodeServerError[EHttpStatusCodeServerError["GatewayTimeout"] = 504] = "GatewayTimeout";
    return EHttpStatusCodeServerError;
}(EHttpStatusCodeServerError || {});
var ERequestError = /*#__PURE__*/ function(ERequestError) {
    ERequestError["NetworkError"] = "networkError";
    ERequestError["BadRequest"] = "badRequest";
    ERequestError["UnprocessableEntity"] = "unprocessableEntity";
    ERequestError["Unauthorized"] = "unauthorized";
    ERequestError["Forbidden"] = "forbidden";
    ERequestError["NotFound"] = "notFound";
    ERequestError["InternalServerError"] = "internalServerError";
    ERequestError["ServiceUnavailable"] = "serviceUnavailable";
    ERequestError["GatewayTimeout"] = "gatewayTimeout";
    ERequestError["Unknown"] = "unknown";
    return ERequestError;
}(ERequestError || {});
export { EHttpStatusCodeSuccess, EHttpStatusCodeRedirection, EHttpStatusCodeClientError, EHttpStatusCodeServerError, ERequestError };
